<template>
<div >
    <p class="title">投标邀请函（邀请后审）</p>
    <div>
        <p>1、查看投标邀请函信息。</p>
        <img src="../assets/help/1.6.1-1.jpg" alt="">
        <p>2、点击“查看邀请函”，查看邀请函信息。</p>
        <img src="../assets/help/1.6.1-2.jpg" alt="">
    </div>
</div>
</template>
<script>
export default {
    name:'center',
    data(){
        return{
            
        }

    }
}
</script>
<style>

</style>